// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"ui","itemsContainer":"vi"};